/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPANDABLE SECTION - SECTION GROUP : STYLES --------------- ++++++++++ */
export default theme => ({
  sectiongroup: {
    '&:not(:first-child)': {
      marginTop: pxToEm(48),
    },
    '&.secondary:not(:first-child)': {
      marginTop: pxToEm(16),
    },
    '&.secondary > .sectiongroupdescription > h2': {
      fontWeight: 500,
      fontSize: pxToEm(14),
      marginBottom: pxToEm(8)
    },
    '&.disabled': {
      filter: 'grayscale(1)',
      opacity: 0.4,
      pointerEvents: 'none'
    },
    '& > .field': {
      // marginTop: pxToEm(16)
    },
    '&.secondary > .field': {
      // marginTop: pxToEm(8)
    },
    '&.row': {
      display: 'flex',
      flexDirection: 'row',
    },
    '&.column': {
      display: 'flex',
      flexDirection: 'column'
    },
    '&.child': {
      marginTop: pxToEm(16),
      marginLeft: pxToEm(56)
    },
    
    '& .toggle': {
      marginRight: pxToEm(8),
      marginTop: pxToEm(2),
      maxWidth: '40px',
      minWidth: '40px',
      height: pxToEm(22),
      '& .ball': {
        height: pxToEm(18),
        width: pxToEm(18)
      }
    }
  }
});
